import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=1f773e84&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f773e84"]])

export default __exports__